<template>
  <!-- Fila etiqueta/valor reutilizable: valor editable (manual-field) o de solo lectura, con chip de fuente. -->
  <div class="kv" :class="{ manual: mode && source === 'none', sourced: mode && source && source !== 'none' }">
    <span class="lbl">{{ label }}</span>
    <span class="val">
      <manual-field v-if="editable" :value="value" :type="type" :options="options" :allow-other="allowOther" :format="format" :block="block"
                    @save="$emit('save', $event)"></manual-field>
      <b v-else>{{ readonlyDisplay }}</b>
      <source-chip v-if="mode && source" :source="source" :tip-override="tipOverride"></source-chip>
      <!-- Extra opcional junto al valor (p. ej. adjuntar documento). -->
      <slot name="extra"></slot>
    </span>
  </div>
</template>

<script>
  import ManualField from './manual-field.vue'
  import SourceChip from './source-chip.vue'

  export default {
    name: 'PrmSummaryKvField',

    components: { ManualField, SourceChip },

    props: {
      label: { type: String, required: true },
      source: { type: String, default: '' }, // chip de origen ('' = sin chip)
      editable: { type: Boolean, default: false },
      value: { type: [String, Number], default: '' },
      type: { type: String, default: 'text' }, // text | date
      options: { type: Array, default: null },
      allowOther: { type: Boolean, default: false }, // select con "Otros" -> texto libre
      format: { type: Function, default: null },
      block: { type: Boolean, default: false }, // input a ancho completo al editar (campos de texto largo)
      tipOverride: { type: String, default: '' },
      mode: { type: Boolean, default: false },
    },

    computed: {
      readonlyDisplay () {
        if (this.value === '' || this.value === null || this.value === undefined) return '-'
        return this.format ? this.format(this.value) : this.value
      },
    },
  }
</script>

<style lang="scss" scoped>
  .kv { display: flex; align-items: center; border-bottom: 1px solid #eef0f3; min-height: 25px; }
  .kv .lbl {
    width: 180px; flex-shrink: 0; padding: 4px 10px; font-size: 9px; font-weight: 700; text-transform: uppercase;
    letter-spacing: .02em; color: #5a7896; background: #f6f8fa; align-self: stretch; display: flex; align-items: center;
  }
  .kv .val { flex: 1; display: flex; align-items: center; gap: 2px; padding: 3px 10px; font-size: 11px; color: #2c3a4d; min-width: 0; }
  .kv .val b { font-weight: 600; }
  // Fila sin fuente (manual) resaltada en ámbar (toda la fila) cuando el modo está activo.
  .kv.manual .lbl, .kv.manual .val { background: #fff4d6; }
  .kv.manual .lbl { color: #8a6d00; }
  // Fila con fuente real: tinte azul suave en modo fuente (evita huecos blancos).
  .kv.sourced .lbl, .kv.sourced .val { background: #eef4fb; }
</style>
